interface BrandLogoProps {
  className?: string;
}

export const BrandLogo = ({ className }: BrandLogoProps) => {
  return (
    <img src="/nhwm.png" alt="National Healthness and Wellness Mission" className={className}/>
  );
};
